import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { getPaymentProviders } from '../ordersThunk';
import { OrdersState, PaymentProvider } from '../types';
import { CustomError } from 'shared/api';

export const getPaymentProvidersReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(
			getPaymentProviders.fulfilled,
			(state, action: PayloadAction<PaymentProvider[]>) => {
        action.payload.forEach(item=>{
          if (!state.paymentProviders.find(el=>el.id===item.id)) {
            state.paymentProviders.push(item);
          }
        })
			},
		)
		.addCase(
			getPaymentProviders.rejected,
			(state, action: PayloadAction<CustomError | undefined>) => {
				if (action.payload) {
					state.error = action.payload;
				}
			},
		)
};